import { render } from "./Spinner.vue?vue&type=template&id=62b94df2&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=62b94df2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b94df2"]])

export default __exports__